import { Component, OnInit, Input } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import { IssueSupplier, IssueUpdateDataSupplier, IssuesFilterSupplier, QuproList, QuproServiceError } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, IssuePopulateService, UiService } from '../../../../services/api.services';
import { IssueFront } from '../../../../models/api.models';

@Component({
  selector: 'app-asignar-operario',
  templateUrl: './asignar-operario.component.html',
  styleUrls: ['./asignar-operario.component.scss'],
})
export class AsignarOperarioComponent implements OnInit {

  @Input() issuesToEdit: IssueSupplier[];
  @Input() isModal: boolean;
  @Input() postsaleFilter: boolean;
  @Input() presaleFilter: boolean;

  showBackButton = false;
  operatorNum: number;
  issuesFilter: IssuesFilterSupplier = new IssuesFilterSupplier();
  issueUpdateDataSupplier: IssueUpdateDataSupplier = new IssueUpdateDataSupplier();
  issuesToSend: IssueSupplier[] = [];
  issuesCantUpdate: IssueSupplier[] = [];

  constructor(private modalCtrl: ModalController, public platform: Platform,
              private portalProveedorService: PortalProveedorService,
              private issuePopulateService: IssuePopulateService,
              private uiService: UiService) { }

  ngOnInit() {
    if (this.platform.is('desktop')) {
      this.showBackButton = false;
    }
    this.issuesToEdit.forEach(issueToEdit => {
      if (issueToEdit.supplier_actions.includes('can_modify_operator_num')) {
        this.issuesToSend.push(issueToEdit);
      } else {
        this.issuesCantUpdate.push(issueToEdit);
      }
    });
  }

  onSubmitTemplate() {
    if (this.operatorNum < 1) {
      const mmms = 'No se puede asignar operarios con valor 0 o negativo';
      this.showErrorToast(mmms);
    } else {
      this.issueUpdateDataSupplier.operator_num = this.operatorNum;
      this.portalProveedorService.updateIssuesOperator(this.issuesToSend, this.issueUpdateDataSupplier).subscribe(resp => {
        const updateIssues: IssueFront[] = [];
        const issuesIds: number[] = [];
        this.issuesToSend.forEach(issue => {
          issuesIds.push(issue.id);
        });
        this.issuesFilter.setIds(issuesIds);
        if (this.postsaleFilter) {
          this.updatePostsaleIssues(updateIssues);
        }
        if (this.presaleFilter) {
          this.updatePresaleIssues(updateIssues);
        }
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
      });
      this.exit();
    }
  }

  exit() {
    this.modalCtrl.dismiss();
  }

  private updatePostsaleIssues(updateIssues: IssueFront[]) {
    this.portalProveedorService.getPostSaleIssuesFromCsiteSupplier('all', this.issuesFilter, null, 0, 0)
    .subscribe((postsaleIssues: QuproList<IssueSupplier>) => {
      updateIssues = this.issuePopulateService.convertirIssuesToPostsaleFrontIssues(postsaleIssues.elements);
      const message = 'Operarios actualizados con éxito. ';
      this.showOkToast(message);
      this.portalProveedorService.updateOperatorEvent.emit(updateIssues);
    }, (error: QuproServiceError) => {
      this.showErrorToast(error.message);
    });
  }

  private updatePresaleIssues(updateIssues: IssueFront[]) {
    this.portalProveedorService.getReviewPresaleIssuesFromSupplier(this.issuesFilter, null, 0, 0)
      .subscribe((presaleIssues: QuproList<IssueSupplier>) => {
        updateIssues = this.issuePopulateService.convertirIssuesToReviewPresaleFront(presaleIssues.elements);
        const message = 'Operarios actualizados con éxito. ';
        this.showOkToast(message);
        this.portalProveedorService.updateOperatorEvent.emit(updateIssues);
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
      });
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

}
